import { Icon, Label } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { OrderItemQuantity } from '../OrderItemQuantity'

const FulfillmentIssueLabel = ({orderItem}) => {
    const [t] = useTranslation();

    const negativeCustomerAckType = ['SUBSTITUTION_REJECTED', 'NO_ANSWER_REJECTED'].includes(orderItem.customerAckType);
    const isPositiveIssue = ['REPLACEMENT_ITEM', 'PARTIAL_AVAILABILITY'].includes(orderItem.fulfillmentIssue) && !negativeCustomerAckType; 

    return (
      <Label
        size="mini"
        color={isPositiveIssue ? 'green' : 'grey'}>
          {t(`order.fulfillment_issue.${orderItem.fulfillmentIssue}`)}
          {orderItem.fulfillmentIssue === 'PARTIAL_AVAILABILITY' &&
            <>
                <Icon style={{ margin: '0 .5rem' }} name="long arrow alternate right"/>
                <OrderItemQuantity
                  orderItem={orderItem}
                  quantity={orderItem.quantity}
                />
            </>
          }
      </Label>
    )
}

export { FulfillmentIssueLabel }
